import { render } from "./WinCard.vue?vue&type=template&id=488c6afc&scoped=true"
import script from "./WinCard.vue?vue&type=script&lang=js"
export * from "./WinCard.vue?vue&type=script&lang=js"

import "./WinCard.vue?vue&type=style&index=0&id=488c6afc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488c6afc"]])

export default __exports__